export const Usage = ({ content }) => {
  return <span>{content}</span>;
};
